/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component, Input, Output, EventEmitter } from "@angular/core";
var wizardHeaderActionIndex = 0;
var WizardHeaderAction = (function () {
    function WizardHeaderAction() {
        // title is explanatory text added to the header action
        this.title = "";
        // If our host has an ID attribute, we use this instead of our index.
        this._id = (wizardHeaderActionIndex++).toString();
        this.disabled = false;
        this.headerActionClicked = new EventEmitter(false);
    }
    Object.defineProperty(WizardHeaderAction.prototype, "id", {
        get: function () {
            return "clr-wizard-header-action-" + this._id;
        },
        enumerable: true,
        configurable: true
    });
    WizardHeaderAction.prototype.click = function () {
        if (this.disabled) {
            return;
        }
        // passing the header action id allows users to have one method that
        // routes to many different actions based on the type of header action
        // clicked. this is further aided by users being able to specify ids
        // for their header actions.
        this.headerActionClicked.emit(this._id);
    };
    return WizardHeaderAction;
}());
export { WizardHeaderAction };
WizardHeaderAction.decorators = [
    { type: Component, args: [{
                selector: "clr-wizard-header-action",
                template: "\n        <button \n            type=\"button\"\n            class=\"btn clr-wizard-header-action btn-link\"\n            [id]=\"id\"\n            [class.disabled]=\"disabled\"\n            (click)=\"click()\"\n            [title]=\"title\">\n            <ng-content></ng-content>\n        </button>\n    ",
                host: {
                    "class": "clr-wizard-header-action-wrapper"
                }
            },] },
];
/** @nocollapse */
WizardHeaderAction.ctorParameters = function () { return []; };
WizardHeaderAction.propDecorators = {
    'title': [{ type: Input, args: ["title",] },],
    '_id': [{ type: Input, args: ["id",] },],
    'disabled': [{ type: Input, args: ["clrWizardHeaderActionDisabled",] },],
    'headerActionClicked': [{ type: Output, args: ["actionClicked",] },],
};
//# sourceMappingURL=wizard-header-action.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/wizard/wizard-header-action.js
// module id = 101
// module chunks = 4